var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "theme-page",
      class: { "with-assist": _vm.isAssistPanelVisible && _vm.showThemeAssist },
    },
    [
      _c(
        "div",
        { staticClass: "theme-page__main" },
        [
          _c(
            "div",
            { staticClass: "theme-page__main-scroll" },
            [_c("theme-editor", { attrs: { novelId: _vm.novelId } })],
            1
          ),
          _vm.showThemeAssist
            ? _c("assist-fab", {
                staticClass: "theme-page__assist-fab",
                attrs: { size: "large" },
                on: { click: _vm.toggleAssistPanel },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.showThemeAssist
        ? _c("assist-panel", {
            staticClass: "assist-panel",
            attrs: { context: "theme" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }